export let computeTextToMultilevel = (text, l2Prefix, l3Prefix) => {
    if (!l2Prefix) l2Prefix = ` • `
    if (!l3Prefix) l3Prefix = ` ◦ `
    let arr = []
    let lines = text.split(`\n`)

    lines.forEach(line => {
        let l1Length = arr.length ? arr.length - 1 : 0
        let l2Length = arr[l1Length] && arr[l1Length]['list'] && arr[l1Length]['list'].length ? arr[l1Length]['list'].length - 1 : 0
        if ("" !== line) {
            // not empty text line
            if (line.startsWith(l3Prefix)) {
                // level 3
                if (!arr[l1Length]) {
                    // has not level 1 parent
                    arr = [{ text: false, list: [{ level1: false, list: [{ level2: line.substring(l3Prefix.length) }] }] }]
                } else if (!arr[l1Length]['list']) {
                    // has not level 2 parent
                    arr.push({
                        text: false,
                        list: [{ level1: false, list: [{ level2: line.substring(l3Prefix.length) }] }]
                    })
                } else if (!Array.isArray(arr[l1Length]['list'][l2Length]['list'])) {
                    arr[l1Length]['list'][l2Length]['list'] = [{ level2: line.substring(l3Prefix.length) }]
                } else {
                    arr[l1Length]['list'][l2Length]['list'].push({ level2: line.substring(l3Prefix.length) })
                }
            } else if (line.startsWith(l2Prefix)) {
                // level 2
                if (!arr[l1Length]) {
                    // has not level 1 parent
                    arr = [{ text: false, list: [{ level1: line.substring(l2Prefix.length), list: false }] }]
                } else if (!Array.isArray(arr[l1Length]['list'])) {
                    arr[l1Length]['list'] = [{ level1: line.substring(l2Prefix.length), list: false }]
                } else {
                    arr[l1Length]['list'].push({ level1: line.substring(l2Prefix.length), list: false })
                }
            } else if (!Array.isArray(arr)) {
                arr = [{ text: line }]
            } else {
                arr.push({ text: line })
            }
        }
    })
    return arr;
}

